import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LOOKUP_LIMIT } from 'app/shared/constants/lookup-limits';
import { Role } from 'app/shared/enums/role';
import { User } from 'app/shared/types/user.types';
import { Users } from 'app/shared/types/users.types';
import { map, Observable } from 'rxjs';

function normalizeUser(user: User): User {
    if (typeof user.role === 'string') {
        user.role = Role[user.role as keyof typeof Role];
    }
    return user;
}

@Injectable({
    providedIn: 'root'
})
export class UserQueryService {
    private readonly _http = inject(HttpClient);

    getUsers(): Observable<Users> {
        // why: the API only pages when both page and pageSize are sent; cap the dropdown lookup at LOOKUP_LIMIT.
        return this._http.get<Users>('api/users', { params: { page: 1, pageSize: LOOKUP_LIMIT } }).pipe(
            map(response => ({
                ...response,
                users: response.users.map(normalizeUser)
            }))
        );
    }

    getUser(): Observable<User> {
        return this._http.get<User>('api/users/me').pipe(
            map(normalizeUser)
        );
    }
}
